import Link from "next/link";
import Logo from "@/components/Logo";

const links = [
  { href: "/marketplace", label: "Marketplace" },
  { href: "/fornecedores", label: "Encontrar empresas" },
  { href: "/como-funciona", label: "Como funciona" },
  { href: "/planos", label: "Planos" },
  { href: "/ajuda", label: "Ajuda" },
  { href: "/termos-de-uso", label: "Termos de uso" },
  {
    href: "/politica-de-privacidade",
    label: "Política de privacidade",
  },
  {
    href: "https://vivaonovo.com.br",
    label: "Viva o Novo",
  },
];

export default function Footer({ tagline = "Tecnologia para Negócios" }: { tagline?: string }) {
  return (
    <footer className="bg-white">
      <div className="mx-auto max-w-[1480px] px-6 pb-6 pt-8">
        <div className="flex flex-col items-center justify-between gap-7 lg:flex-row">
          <Logo compact tagline={tagline} />

          <nav
            aria-label="Links do rodapé"
            className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-center text-sm font-semibold text-slate-700"
          >
            {links.map((link) => (
              <Link
                key={link.href}
                href={link.href}
                className="transition-colors hover:text-blue-600"
              >
                {link.label}
              </Link>
            ))}
          </nav>
        </div>

        <div className="mt-8 border-t border-slate-200 pt-5">
          <p className="text-center text-xs font-medium text-slate-600">
            © 2026 Fornecedor.Net Tecnologia LTDA • CNPJ 69.418.165/0001-84 • Todos os direitos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
}
